
import Vue from 'vue'
import _ from 'lodash'
import { DEFAULT_PAGE_SIZE } from '@/config/app'
import { i18n } from '@/i18n'

const getDefaultState = () => {
  return {
    paginationInfo: {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    },
    currentPage: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: null,
    order: null,
    filters: [],
    masterFilters: {
      id: { label: i18n.t('configurations.id'), value: '' },
      CodigoTramite: { label: i18n.t('presentations.CodigoTramite'), value: '' },
      DescripcionTramite: { label: i18n.t('presentations.DescripcionTramite'), value: '' },
      Asunto: { label: i18n.t('presentations.Asunto'), value: '' },
      Telefono: { label: i18n.t('presentations.Telefono'), value: '' },
      Email: { label: i18n.t('presentations.Email'), value: '' },
      PresentarRecurso: { label: i18n.t('presentations.PresentarRecurso'), value: '' },
      Observaciones: { label: i18n.t('presentations.Observaciones'), value: '' },
      NumAsiento: { label: i18n.t('presentations.NumAsiento'), value: '' },
      CSVRecibo: { label: i18n.t('presentations.CSVRecibo'), value: '' },
      URLRecibo: { label: i18n.t('presentations.URLRecibo'), value: '' },
      FechaPresentacion: { label: i18n.t('presentations.FechaPresentacion'), value: '' },
      tipoPresentacionEstado: { label: i18n.t('presentations.Estado'), value: '' },
      Error: { label: i18n.t('presentations.Error'), value: '' },
    },
    notUseLikeTags: ['results', 'page', 'sort', 'order'],
    kendo: {
      columns: [
        { field: 'selected', width: '50px', minResizableWidth: 50, headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
        { field: 'idPresentacion', width: '100px', minResizableWidth: 50, title: i18n.t('configurations.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
        { field: 'CodigoTramite', width: '250px', minResizableWidth: 187, title: i18n.t('presentations.CodigoTramite'), columnMenu: 'myTemplate', locked: false },
        { field: 'DescripcionTramite', width: '250px', minResizableWidth: 187, title: i18n.t('presentations.DescripcionTramite'), columnMenu: 'myTemplate', locked: false },
        { field: 'Estado', width: '250px', minResizableWidth: 187, title: i18n.t('presentations.Estado'), columnMenu: 'myTemplate', locked: false },
        { field: 'Asunto', width: '250px', minResizableWidth: 187, title: i18n.t('presentations.Asunto'), columnMenu: 'myTemplate', locked: false },
        { field: 'NumAsiento', width: '250px', minResizableWidth: 187, title: i18n.t('presentations.NumAsiento'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'CSVRecibo', width: '250px', minResizableWidth: 187, title: i18n.t('presentations.CSVRecibo'), columnMenu: 'myTemplate', locked: false },
        { 
          field: 'URLRecibo', 
          width: '250px', 
          minResizableWidth: 187,
          title: i18n.t('presentations.URLRecibo'), 
          columnMenu: 'myTemplate', 
          cell: 'urlTemplate',
          locked: false 
        },
        {
          field: 'FechaPresentacion',
          title: i18n.t('presentations.FechaPresentacion'),
          type: 'date',
          filter: 'date',
          format: '{0:dd-MM-yyyy HH:mm}',
          columnMenu: 'myTemplate',
          locked: false,
          width: '220px',
          minResizableWidth: 165
        },
        { field: 'Telefono', width: '250px', minResizableWidth: 187, title: i18n.t('presentations.Telefono'), columnMenu: 'myTemplate', locked: false },
        { field: 'Email', width: '250px', minResizableWidth: 187, title: i18n.t('presentations.Email'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'PresentaRecurso', width: '200px', minResizableWidth: 100, title: i18n.t('presentations.PresentarRecurso'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        { field: 'Observaciones', width: '300px', minResizableWidth: 150, title: i18n.t('presentations.Observaciones'), columnMenu: 'myTemplate', locked: false },
        { field: 'Error', width: '250px', minResizableWidth: 187, title: i18n.t('presentations.Error'), columnMenu: 'myTemplate', locked: false, hidden: true },
      ],
      skip: 0,
      take: 10,
      sortable: true,
      groupable: true,
      sort: [],
      group: [],
      filter: null,
      columnMenu: true,
      dataResult: null,
      navigate: false
    }
  }
}

const state = getDefaultState()

const getters = {
  getPayloadCurrentPage: state => state.paginationInfo.currentPage,
  getPayloadPageSize: state => state.paginationInfo.pageSize,
  getPayloadTotal: state => state.paginationInfo.total,
  getPayLoadTotalPages: state => state.paginationInfo.totalPages,
  getMasterFilters: state => state.masterFilters,
  getCurrentPage: state => state.currentPage,
  getPageSize: state => state.pageSize,
  getKendo: state => state.kendo,
  getNotificationsNumber: state => state.notificationsNumber,
  getPaginationInfo: state => {
    state.paginationInfo.pageSize = state.pageSize
    return state.paginationInfo
  },
  getFilters: (state) => {
    state.filters.results = state.pageSize
    state.filters.page = state.currentPage
    if (state.order) {
      state.filters.order = state.order
    } else {
      delete (state.filters.order)
    }
    if (state.sort && state.filters.order) {
      state.filters.sort = state.sort
    } else {
      delete (state.filters.sort)
    }
    return state.filters
  },
  getTags: (state) => {
    const tags = []
    _.each(state.filters, (item, key) => {
      if (state.notUseLikeTags.indexOf(key) === -1) {
        tags.push([key, item.label, item.value])
      }
    })
    return tags
  },
  getAppliedFilters (state) {
    const data = {}
    const _temp = Object.entries(state.masterFilters)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.filters = data
    return data
  }
}

const mutations = {
  setKendoColumns (state, data) {
    data.unshift('selected')
    state.kendo.columns = state.kendo.columns.map(x => {
      if (data.includes(x.field)) {
        x.hidden = false
      } else {
        x.hidden = true
        data.push(x.field)
      }
      return x
    }).sort((a, b) => data.indexOf(a.field) - data.indexOf(b.field))
  },
  setKendo (state, kendo) {
    state.kendo = kendo
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  resetStateWithoutSort (state, data) {
    Object.assign(state, getDefaultState())
    // Object.assign(state, getDefaultState())
    state.kendo.sort = data.sort
    state.kendo.group = data.group
  },
  resetPaginationInfo (state, data) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.paginationInfo = {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    }
  },
  setPaginationInfo (state, data) {
    state.paginationInfo = data
  },
  setSort (state, fieldName) {
    state.sort = fieldName
  },
  setSortOrder (state, order) {
    switch (order) {
      case 'ascending':
        state.order = 'asc'
        break
      case 'descending':
        state.order = 'desc'
        break
      default:
        state.order = null
        state.sort = null
    }
  },
  setNotUseLikeTags (state, items = []) {
    state.notUseLikeTags = items
  },
  setMasterFilters (state, master) {
    const data = {}
    const _temp = Object.entries(master)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.masterFilters = data
    // console.log(data)
  },
  setNotificationsNumber (state, notificationsNumber) {
    state.notificationsNumber = notificationsNumber
  },
  resetNotificationsNumber () {
    state.notificationsNumber = {}
  },
  removeTag (state, tag) {
    const path = tag.split('.')
    if (path.length === 1) {
      state.masterFilters[path[0]] = ''
    }
    if (path.length === 2) {
      state.masterFilters[path[0]][path[1]] = ''
    }
  },
  resetMasterFilters (state) {
    state.masterFilters = {
      id: { label: i18n.t('configurations.id'), value: '' },
      CodigoTramite: { label: i18n.t('presentations.CodigoTramite'), value: '' },
      DescripcionTramite: { label: i18n.t('presentations.DescripcionTramite'), value: '' },
      Asunto: { label: i18n.t('presentations.Asunto'), value: '' },
      Telefono: { label: i18n.t('presentations.Telefono'), value: '' },
      Email: { label: i18n.t('presentations.Email'), value: '' },
      PresentarRecurso: { label: i18n.t('presentations.PresentarRecurso'), value: '' },
      Observaciones: { label: i18n.t('presentations.Observaciones'), value: '' },
      NumAsiento: { label: i18n.t('presentations.NumAsiento'), value: '' },
      CSVRecibo: { label: i18n.t('presentations.CSVRecibo'), value: '' },
      URLRecibo: { label: i18n.t('presentations.URLRecibo'), value: '' },
      FechaPresentacion: { label: i18n.t('presentations.FechaPresentacion'), value: '' },
      tipoPresentacionEstado: { label: i18n.t('presentations.Estado'), value: '' },
      Error: { label: i18n.t('presentations.Error'), value: '' },
    }
  },
  setFilter (state, { key, value }) {
    Vue.set(state.filters, { key: value })
  },
  setFilters (state, thefilters) {
    Vue.set(state, 'filters', thefilters)
  },
  clearFilters (state) {
    Vue.set(state, 'filters', [])
  },
  clearPagination (state) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.currentPage = 1
  },
  setPageSize (state, size) {
    state.pageSize = size
  },
  setCurrentPage (state, pageNumner) {
    if (pageNumner > 0 && pageNumner <= state.paginationInfo.totalPages) {
      state.currentPage = pageNumner
      state.paginationInfo.currentPage = pageNumner
    }
  }
}

const actions = {
  resetCartState ({ commit }) {
    commit('resetState')
  },
  resetStateWithoutSort ({ commit, rootGetters }) {
    const data = {
      sort: rootGetters['neopresentationsPersisted/getSort'],
      group: rootGetters['neopresentationsPersisted/getGroup'],
    }
    commit('resetStateWithoutSort', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
